import type { Toast } from "@components/Toast.js";
import { toasts } from "../state/toasts.svelte.js";

interface GroupEntry {
	id: string;
	timeoutId: ReturnType<typeof setTimeout>;
}

const groups = new Map<string, GroupEntry>();

export function openToast(input: Omit<Toast, "id" | "close"> & { group?: string }): Toast {
	const { group, ...toastInput } = input;

	if (group !== undefined) {
		const existing = groups.get(group);
		if (existing !== undefined) {
			clearTimeout(existing.timeoutId);
			toasts.items = toasts.items.filter((t) => t.id !== existing.id);
		}
	}

	const id = crypto.randomUUID();

	function close(): void {
		toasts.items = toasts.items.filter((t) => t.id !== id);
		if (group !== undefined && groups.get(group)?.id === id) {
			groups.delete(group);
		}
	}

	const toast: Toast = {
		...toastInput,
		id,
		close,
	};

	toasts.items.push(toast);
	const timeoutId = setTimeout(close, toasts.toastDelay);

	if (group !== undefined) {
		groups.set(group, { id, timeoutId });
	}

	return toast;
}
